function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 138.9 168"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#CEB320",
  d: "M122.87 114.97H17.27c-6 0-10.9 4.9-10.9 10.9v41.9h127.5v-41.8c-.1-6.1-4.9-11-11-11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0D5275",
  d: "M103.17 48.37h-67.2c-9.6 0-17.3 7.8-17.3 17.4v102h101.9v-102c0-9.6-7.8-17.4-17.4-17.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFEDD3",
  d: "M103.07 99.87c0-1.5-.3-2.9-.8-4.2 11.3 1.9 21.1-1.2 25.5-8.2 3.4-5.3 3.6-12.3.6-19.8-3.2-8-9.6-15.4-18.1-21l4.5-7.1c9.9 6.4 17.5 15.2 21.4 24.9 4.1 10.1 3.6 19.9-1.4 27.5-5.2 8-14.9 12.5-26.2 12.5-1.8 0-3.7-.1-5.5-.3v-4.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8E7D0",
  d: "M117.47 52.27l-2.1-12.8-8.4-.5-3.4 8.4c5.1-.1 10 1.6 13.9 4.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F4DC",
  d: "M93.77 88.87h-46.9c-6.1 0-11 4.9-11 11v67.9h68.9v-67.9c0-6.1-4.9-11-11-11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#332C23",
  d: "M35.87 154.47h68.9v13.3h-68.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A74B4",
  d: "M105.87 77.47h-74c-5.4 0-9.7-4.4-9.7-9.8v-2.2c0-8.1 6.6-14.7 14.7-14.7h64.2c8.1 0 14.7 6.6 14.7 14.7v2.2c-.2 5.4-4.5 9.8-9.9 9.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8E7D0",
  d: "M93.87 88.87h-47.1c-4.4 0-8 3.6-8 8v57.6h63v-57.6c.1-4.5-3.5-8-7.9-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D9D7C3",
  d: "M79.47 108.07h-19.8c-8.8 0-16-7.2-15.9-16v-1.5c0-1 .8-1.8 1.8-1.8h48.2c1 0 1.8.8 1.8 1.8v1.5c-.1 8.8-7.3 16-16.1 16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFA973",
  d: "M76.27 88.87c0 6-2.9 10.9-6.4 10.9-3.5 0-6.4-4.8-6.4-10.9h12.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#73B843",
  d: "M71.47 99.37a4.01 4.01 0 01-3 0l-4.9 3.2v.1l2.5 5.4-2 33.1 5.9 8.4 5.9-8.4-2-33.1 2.5-5.4-4.9-3.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: "10",
  d: "M80.17 88.87h-21.2c-9 0-16.2-7.3-16.2-16.3v-23.5c0-14.8 12-26.8 26.8-26.8a27 27 0 0126.8 26.8v23.5c0 8.9-7.2 16.2-16.2 16.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC91",
  stroke: "#FFCC91",
  strokeMiterlimit: "10",
  d: "M80.07 88.87h-21.1c-9 0-16.2-7.3-16.2-16.3v-19.8c0-14.8 12-26.8 26.8-26.8a27 27 0 0126.8 26.8v19.8c0 8.9-7.3 16.2-16.3 16.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED7447",
  d: "M101.87 14.37c1.6-8.1-2-9.5-2-9.4-.9 3-3 5.9-6.6 5.3-3.8-.6-6.6-3.6-9.6-5.5-5.1-3.4-11.2-5-17.3-4.8-20.7 1-22.1 19.2-22.1 19.2-14.8 4.4-1.5 34.9-1.5 34.9v-1.4c0-14.8 12-26.8 26.8-26.8a27 27 0 0126.8 26.8v1.4c2.2-6.5 3.6-13.2 4.1-20.1.3-3.6 1-7.8-.9-11.1-.4-.7-2.2-3.1-3.1-2.8 2.7-.7 4.7-2.9 5.4-5.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F69370",
  d: "M49.17 22.27s-2-12.8 10.3-17.3c0 0 12.8-3.9 21.7 3 0 0 7.8 5.2 11.3 2.4-3.4-.4-6-3.7-8.8-5.4-5.1-3.4-11.2-5.1-17.3-4.8-20.7 1-22.1 19.2-22.1 19.2-1.7.5-3.3 1.5-4.4 3 4.3-3.6 9.3-.1 9.3-.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF5822",
  d: "M101.77 14.37c.6-2.2.6-4.5 0-6.8 1.4 6.3-2.4 8-5.7 9.5-3.9 1.9-8.3 2.7-12.6 2.3-4.5-.7-8.7-2.3-12.5-4.8-2.2-1.3-4.2-2.9-6.7-3.5-2.4-.5-5-.1-7.1 1.1-1.9.8-3.4 2.1-4.5 3.8a9.3 9.3 0 00-1.1 4.9c0 1.4.3 2.8.7 4.1.1.6.3 1.2.6 1.7-3.4-3.5-6.4-2.5-6.4-2.5-11.3-1.5-3.9 30-3.9 30v-1.4c0-14.8 12-26.8 26.8-26.8a27 27 0 0126.8 26.8v1.4c2.2-6.5 3.6-13.2 4.1-20.1.3-3.7 1-7.8-.9-11.1-.4-.7-2.2-3.1-3.1-2.8 2.8-.8 4.9-3 5.5-5.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFEDD3",
  d: "M35.9 99.83c0-1.5.3-2.9.8-4.2-11.3 1.9-21.1-1.2-25.5-8.2-3.4-5.3-3.6-12.3-.6-19.8 3.2-8 9.6-15.4 18.1-21l-4.5-7.1c-9.9 6.4-17.5 15.2-21.4 24.9-4.1 10.1-3.6 19.9 1.4 27.5 5.2 8.1 14.9 12.6 26.3 12.6 1.8 0 3.7-.1 5.5-.3v-4.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8E7D0",
  d: "M21.4 52.23l2.1-12.8 8.4-.5 3.4 8.4c-5-.1-10 1.6-13.9 4.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBC581",
  d: "M38.2 48.53c-2 .5-4-.6-4.6-2.6l-1.9-6.9c-.5-2 .6-4 2.6-4.6 2-.5 4 .6 4.6 2.6l1.9 6.9c.5 2-.6 4.1-2.6 4.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBA975",
  d: "M42.77 56.07c-.2-1.1-1.2-1.8-2.3-1.6-1.1.2-1.8 1.1-1.6 2.2v.1l1.9 11.7c.2 1 1 1.7 2 1.6v-14zm55.4-1.7c-.7-.1-1.3.1-1.8.6v14.9c.8-.2 1.4-.8 1.5-1.6l1.9-11.7c.2-1-.5-2-1.6-2.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECEBD7",
  d: "M63.42 88.88l-4.3.1-1.1 15.1 1.5 1 3.9-2.6 4.9-3.2c-2.8-1.1-4.9-5.3-4.9-10.4zm12.8 0l4.3.1 1.1 15.1-1.5 1-3.9-2.6-4.9-3.2c2.7-1.1 4.8-5.3 4.9-10.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6CD26",
  d: "M125.27 126.57h-8.5c-2.4 0-4.4 2-4.4 4.4v37h17.2v-37c.1-2.4-1.8-4.3-4.2-4.4h-.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CEB320",
  d: "M124.27 127.57h-8.6a2.9 2.9 0 00-2.9 2.9v37.6h15.8v-36.1c.1-2.4-1.8-4.3-4.2-4.4h-.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6CD26",
  d: "M14.37 126.57h8.5c2.4 0 4.4 2 4.4 4.4v37h-17.2v-37c-.1-2.4 1.8-4.4 4.3-4.4-.1 0 0 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CEB320",
  d: "M15.37 127.57h8.6c1.6 0 2.9 1.3 2.9 2.9v37.6h-15.8v-36.1c-.1-2.4 1.8-4.4 4.3-4.4-.1 0-.1 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB182",
  d: "M69.37 69.07a3 3 0 01-3-3l2.5-22.2h1.5l2 22.2c-.1 1.7-1.4 3-3 3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFB268",
  d: "M69.3 76.75h-.1c-3.5 0-7-1-10-2.9-.3-.2-.4-.7-.2-1 .2-.3.6-.4 1-.2a17.2 17.2 0 0018.5 0c.4-.2.8-.1 1 .3.2.3.1.8-.2 1-3 1.8-6.4 2.8-10 2.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#654F2C",
  d: "M48.54 45.27c-.8 0-1.4-.6-1.4-1.4 0-3.5 2.8-6.4 6.3-6.4h.8c1.7 0 3.3.7 4.5 1.9.5.5.5 1.4 0 1.9s-1.4.5-1.9 0c-.7-.7-1.6-1.1-2.6-1.1h-.8c-2 0-3.6 1.6-3.6 3.6.1.7-.5 1.3-1.2 1.4 0 .1-.1.1-.1.1zm41.82 0c.8 0 1.4-.6 1.4-1.4 0-3.5-2.8-6.3-6.3-6.4h-.8c-1.7 0-3.3.7-4.5 1.9-.5.5-.5 1.4.1 1.9.5.5 1.3.5 1.8 0 .7-.7 1.6-1.1 2.6-1.1h.8c2 0 3.6 1.6 3.6 3.6-.1.9.5 1.5 1.3 1.5-.1 0 0 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFB268",
  d: "M55.04 56.75c-2.7 0-4.9-2.7-4.9-5.9 0-.3.2-.5.5-.5s.5.2.5.5c0 2.7 1.8 4.9 3.9 4.9s3.9-2.2 3.9-4.9c0-.3.2-.5.5-.5s.5.2.5.5c0 3.2-2.2 5.9-4.9 5.9zm28.55 0c-2.7 0-4.9-2.7-4.9-5.9 0-.3.2-.5.5-.5s.5.2.5.5c0 2.7 1.8 4.9 3.9 4.9s3.9-2.2 3.9-4.9c0-.3.2-.5.5-.5s.5.2.5.5c0 3.2-2.2 5.9-4.9 5.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFEDD3",
  d: "M35.9 99.83c0-1.5.3-2.9.8-4.2-11.3 1.9-21.1-1.2-25.5-8.2-3.4-5.3-3.6-12.3-.6-19.8 3.2-8 9.6-15.4 18.1-21l-4.5-7.1c-9.9 6.4-17.5 15.2-21.4 24.9-4.1 10.1-3.6 19.9 1.4 27.5 5.2 8.1 14.9 12.6 26.3 12.6 1.8 0 3.7-.1 5.5-.3v-4.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8E7D0",
  d: "M21.4 52.23l2.1-12.8 8.4-.5 3.4 8.4c-5-.1-10 1.6-13.9 4.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBC581",
  d: "M38.2 48.53c-2 .5-4-.6-4.6-2.6l-1.9-6.9c-.5-2 .6-4 2.6-4.6 2-.5 4 .6 4.6 2.6l1.9 6.9c.5 2-.6 4.1-2.6 4.6zm62.57.04c2 .5 4-.6 4.6-2.6l1.9-6.9c.5-2-.6-4-2.6-4.6-2-.5-4 .6-4.6 2.6l-1.9 6.9c-.5 2 .6 4 2.6 4.6z"
})));